"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function elementScroll(element, position = { top: 0, left: 0 }) {
    if (!element)
        return position;
    const { top, left } = position;
    return elementScroll(element === null || element === void 0 ? void 0 : element.parentElement, {
        top: top + element.scrollTop,
        left: left + element.scrollLeft,
    });
}
exports.default = elementScroll;
//# sourceMappingURL=elementScroll.js.map